import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ms-10" }, "FELIX TIME MANAGEMENT", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "sidebar-menu" }
const _hoisted_7 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", { class: "sub-title sidebar-nav-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Menus")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-date" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Attendance", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "accordion-body" }
const _hoisted_14 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_15 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_16 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_17 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_18 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_19 = {
  key: 1,
  class: "sidebar-nav-item"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-date" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "OT", -1)
const _hoisted_22 = {
  key: 2,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Leave", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "accordion-body" }
const _hoisted_27 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_28 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_29 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_30 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_31 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_32 = {
  key: 3,
  class: "sidebar-nav-item"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Employee", -1)
const _hoisted_35 = {
  key: 4,
  class: "sidebar-nav-item"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Holiday", -1)
const _hoisted_38 = {
  key: 5,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-date" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Report", -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "accordion-body" }
const _hoisted_43 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_44 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_45 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_46 = {
  key: 2,
  class: "sidebar-sub-menu-item"
}
const _hoisted_47 = {
  key: 3,
  class: "sidebar-sub-menu-item"
}
const _hoisted_48 = {
  key: 6,
  class: "sidebar-nav-item"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-3" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "User & Permission", -1)

import { usePageStore } from '@/store/page'
import { ref, watch } from 'vue'
import { useSessionStore } from '@/store/sessions'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainSidebar',
  setup(__props) {

const pageStore = usePageStore()
const sessionStore = useSessionStore()
const route = useRoute()

const openMenu = ref<string>('')

const menuRouteMap: Record<string, string> = {
    '/': 'attendance',
    '/request-attendance': 'attendance',
    '/manual-attendance': 'attendance',
    '/request-checkin': 'attendance',
    '/leave-request': 'leave',
    '/leave-approved': 'leave',
    '/leave-entitlement': 'leave',
    '/leave-settings': 'leave',
    '/attendance-report': 'report',
    '/leave-report': 'report',
    '/ot-report': 'report',
    '/checkin-report': 'report',
}

const setMenuFromRoute = () => {
    openMenu.value = menuRouteMap[route.path] || ''
}

setMenuFromRoute()

watch(() => route.path, setMenuFromRoute)

const toggleMenu = (menu: string) => {
    openMenu.value = openMenu.value === menu ? '' : menu
}

watch(() => pageStore.openMenu, () => {})

const handleOpenBurgerMenu = () => {
    pageStore.toggleOpenMenu()
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _unref(pageStore).openMenu },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: handleOpenBurgerMenu
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        _hoisted_8,
        (_unref(sessionStore).checkMenuPermission('attendance-today') || _unref(sessionStore).checkMenuPermission('attendance-request') || _unref(sessionStore).checkMenuPermission('attendance-manual') || _unref(sessionStore).checkMenuPermission('attendance-checkin'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass(["accordion-button rounded-0 shadow-none bg-transparent d-block", { collapsed: openMenu.value !== 'attendance' }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleMenu('attendance')), ["prevent"]))
              }, _hoisted_12, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["accordion-collapse collapse", { show: openMenu.value === 'attendance' }])
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("ul", _hoisted_14, [
                    (_unref(sessionStore).checkMenuPermission('attendance-today'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                          _createVNode(_component_router_link, {
                            to: "/",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Today ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('attendance-request'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                          _createVNode(_component_router_link, {
                            to: "/request-attendance",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Request ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('attendance-manual'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                          _createVNode(_component_router_link, {
                            to: "/manual-attendance",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Manual ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('attendance-checkin'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                          _createVNode(_component_router_link, {
                            to: "/request-checkin",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" CheckIn ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_unref(sessionStore).checkMenuPermission('ot-today'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
              _createVNode(_component_router_link, {
                to: "/ot-request",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_20,
                  _hoisted_21
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(sessionStore).checkMenuPermission('leave-list') || _unref(sessionStore).checkMenuPermission('leave-entitlement-view') || _unref(sessionStore).checkMenuPermission('leave-type-manage'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass(["accordion-button rounded-0 shadow-none bg-transparent d-block", { collapsed: openMenu.value !== 'leave' }]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (toggleMenu('leave')), ["prevent"]))
              }, _hoisted_25, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["accordion-collapse collapse", { show: openMenu.value === 'leave' }])
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("ul", _hoisted_27, [
                    (_unref(sessionStore).checkMenuPermission('leave-list'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                          _createVNode(_component_router_link, {
                            to: "/leave-request",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Request ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('leave-list'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                          _createVNode(_component_router_link, {
                            to: "/leave-approved",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Approved ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('leave-entitlement-view'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                          _createVNode(_component_router_link, {
                            to: "/leave-entitlement",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Entitlement ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('leave-type-manage'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                          _createVNode(_component_router_link, {
                            to: "/leave-settings",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Settings ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_unref(sessionStore).checkMenuPermission('employee'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
              _createVNode(_component_router_link, {
                to: "/employee",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_33,
                  _hoisted_34
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(sessionStore).checkMenuPermission('holiday-list'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
              _createVNode(_component_router_link, {
                to: "/holiday",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_36,
                  _hoisted_37
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(sessionStore).checkMenuPermission('report-attendance') || _unref(sessionStore).checkMenuPermission('report-leave'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass(["accordion-button rounded-0 shadow-none bg-transparent d-block", { collapsed: openMenu.value !== 'report' }]),
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (toggleMenu('report')), ["prevent"]))
              }, _hoisted_41, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["accordion-collapse collapse", { show: openMenu.value === 'report' }])
              }, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("ul", _hoisted_43, [
                    (_unref(sessionStore).checkMenuPermission('report-attendance'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                          _createVNode(_component_router_link, {
                            to: "/attendance-report",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Attendance ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('report-leave'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                          _createVNode(_component_router_link, {
                            to: "/leave-report",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Leave ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('report-attendance'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                          _createVNode(_component_router_link, {
                            to: "/ot-report",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" OT ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sessionStore).checkMenuPermission('report-attendance'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                          _createVNode(_component_router_link, {
                            to: "/checkin-report",
                            class: "sidebar-sub-menu-link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Check In ")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_unref(sessionStore).checkMenuPermission('user'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
              _createVNode(_component_router_link, {
                to: "/user-permission",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_49,
                  _hoisted_50
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})